import LocalizedStrings from 'localized-strings';

import { IdType } from './libs/constants';

const locales = new LocalizedStrings({
  en: {
    description:
      'Since you don’t have a proof of address in your name, we are legally required to ask you for the ID document of your host.',
    idCard: 'ID card',
    next: 'Continue',
    passport: 'Passport',
    residencePermit: 'Residence permit',
    selectDocumentType: 'Choose the type of document',
    selectLabel: 'Type of ID document',
    title: 'Your host ID',
    upload: {
      [IdType.Id]: 'Upload your host ID',
      [IdType.ResidencePermit]: 'Upload your host residence permit',
      [IdType.Passport]: 'Upload your host passport',
    },
  },
  fr: {
    description:
      'Vous n’avez pas de justificatif de domicile à votre nom\u00A0; nous devons donc vous demander la pièce d’identité de votre hébergeur.',
    idCard: 'Carte d’identité',
    next: 'Continuer',
    passport: 'Passeport',
    residencePermit: 'Titre de séjour',
    selectDocumentType: 'Choisissez le type de document',
    selectLabel: 'Type de pièce d’identité',
    title: 'Pièce d’identité de l’hébergeur',
    upload: {
      [IdType.Id]: 'Ajoutez la carte d’identité',
      [IdType.ResidencePermit]: 'Ajoutez le titre de séjour',
      [IdType.Passport]: 'Ajoutez le passeport',
    },
  },
} as const);

export default locales;
